/* eslint-disable */
import { defineStore } from 'pinia'
import axios from 'axios'
import {configStore} from "@/store/configStore";
import {userStore} from "@/store/userStore";
import {aSyncData} from "@/modules/main";

const error = new ErrorEvent('doof')

export const authStore = defineStore('auth', {
    state: () => ({
        isAuth: false,
        nodeToken: null,
        cookie:  localStorage.getItem('cookie'),
        sessionID: localStorage.getItem('sessionID'),
        lastActivity: 0
    }),
    actions: {
        /**
         * login via vue
         * @param email {string}
         * @param password {string}
         * @param cookie {bool}
         * @returns {Promise}
         */
        login(email, password, cookie) {
            const _this = this
            return new Promise((resolve, reject) => {
                const config = configStore()
                const user = userStore()
                aSyncData('login/login', {email: email, password: password, cookie: cookie})
                    .then((response) => {
                        console.log(response)
                        switch(response.status){
                            case 250:
                                const data = response.data
                                _this.saveData(data)
                                resolve(250)
                                break;

                            case 251:
                                _this.isAuth = false
                                reject(error);
                                break;

                            default:
                                _this.isAuth = false
                                reject(error);
                                break;
                        }
                    })
                    .catch((e)=> {
                        console.error(e)
                        reject(4)
                    })
            })
        },
        /**
         * reset Password
         * @param email
         * @returns {Promise<unknown>}
         */
        resetPassword(email) {
            const _this = this
            return new Promise((resolve, reject) => {
                const fD = new FormData()
                fD.append('email', email)

                const config = configStore()
                const user = userStore()
                axios.post(config.projectURL+'login/reset',fD)
                    .then((response) => {
                        resolve(response.status)
                    })
                    .catch(()=> reject(error))
            })
        },

        /**
         * use key to reset password
         * @param key
         * @returns {Promise<unknown>}
         */
        restorePassword(token, password) {
            const _this = this
            return new Promise((resolve, reject) => {
                const config = configStore()
                const fD = new FormData()
                fD.append('token', token)
                fD.append('password', password)
                axios.post(config.projectURL+'login/restore',fD)
                    .then((response) => {
                        resolve(response.status)
                    })
                    .catch(()=> reject(error))
            })
        },

        /**
         * @param email
         * @param firstname
         * @param lastname
         * @param password
         * @param avatar
         * @param invite
         * @returns {Promise<unknown>}
         */
        register(firstname, lastname, password, token, phone, dob) {
            return new Promise((resolve, reject) => {
                aSyncData('login/register', {
                    firstname: firstname,
                    lastname: lastname,
                    password: password,
                    token: token,
                    phone: phone,
                    dob: dob
                })
                    .then(r => {
                        console.log(r)
                        switch(r.status){
                            case 250:
                                const data = r.data
                                this.saveData(data)
                                resolve(250)
                                break;

                            default:
                                this.isAuth = false
                                reject(r.data);
                                break;
                        }
                    })
                    .catch((e)=> {
                        reject(error)
                    })
            })
        },
        /**
         *
         * @returns {Promise<unknown>}
         */
        logout() {
            const _this = this
            const user = userStore()
            const config = configStore()

            axios.post(config.projectURL + 'login/logout')
                .then(function (response) {
                    if (response.status === 250) {
                        localStorage.clear()
                        sessionStorage.clear()
                        localStorage.setItem('darkMode', JSON.stringify(config.darkMode))

                        user.$reset()
                        _this.$reset()

                        const cookies = document.cookie.split(';')

                        for (var i = 0; i < cookies.length; i++) {
                            const cookie = cookies[i]
                            const eqPos = cookie.indexOf('=')
                            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
                            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
                        }
                        _this.$router.push('/')
                    }
                })
                .catch((e) => {
                    console.error('doof', e)
                })
        },
        /**
         * Updates Status, checks Login
         * @returns {Promise}
         */
        update() {
            const _this = this
            const user = userStore()
            const config = configStore()
            return new Promise(function (resolve, reject) {
                if (_this.isAuth && (_this.lastActivity + 60000) > Date.now()) {
                    resolve()
                }
                else if (_this.sessionID != null) {
                    _this.lastActivity = Date.now()
                    const fD = new FormData()
                    //BEHEBUNG
                    fD.append('sessionID', _this.sessionID)
                    axios.post(config.projectURL + 'login/update', fD)
                        .then((response) => {
                            if (response.status === 250){
                                const data = response.data
                                _this.saveData(data)
                                resolve(response.status)
                            }else{
                                _this.sessionID = null
                                localStorage.removeItem('sessionID')
                                _this.cookieLogin()
                                    .then(() => {
                                        _this.isAuth = true
                                        resolve()
                                    })
                                    .catch((e) => {
                                        _this.isAuth = false
                                        reject(error)
                                    })
                            }
                        })
                        .catch((e) => {
                            reject(e)
                        })
                }
                else if(_this.cookie != null){
                    _this.cookieLogin()
                        .then(() => {
                            _this.isAuth = true
                            resolve()
                        })
                        .catch((e) => {
                            _this.isAuth = false
                            reject(e)
                        })
                }else{
                    reject(error)
                }
            })
        },
        /**
         *
         * @returns {Promise<unknown>}
         */
        cookieLogin () {
            const _this = this
            return new Promise(function (resolve, reject) {
                const config = configStore()
                const user = userStore()
                try {
                    if (_this.cookie != null) {
                        const fD = new FormData()
                        fD.append('cookie', _this.cookie)
                        axios.post(config.projectURL + 'login/cookie', fD)
                            .then((response) => {
                                if (response.status == 250) {
                                    const data = response.data
                                    _this.saveData(data)
                                    resolve(1);
                                } else {
                                    _this.$reset()
                                    user.$reset()
                                    localStorage.removeItem('sessionID')
                                    localStorage.removeItem('cookie')
                                    reject(error)
                                }
                            })
                            .catch(e => {
                                reject(e)
                            })
                    }else{
                        reject(error)
                    }
                } catch (e) {
                    reject(error)
                }
            })
        },

        /**
         *
         * @param data
         */
        saveData(data){
            const config = configStore()
            const user = userStore()

            user.id = data.userId
            user.email = data.email
            user.firstname = data.firstname
            user.lastname = data.lastname
            user.avatar = data.avatar
            user.credits = data.credits
            user.ipCity = data.ipCity
            config.darkMode = data.darkMode
            if(data.cookie){
                this.cookie = data.cookie
                localStorage.setItem('cookie', data.cookie)
            }
            localStorage.setItem('sessionID', data.sessionId)
            this.sessionID = data.sessionID
            this.nodeToken = data.nodeToken
            this.isAuth = true
            this.lastActivity = Date.now()
        }
    }
})